import { Dispatch } from "react";
import { MFAFlowAction } from "common-client/utils/useMFAFlow";
import { LoginResponse } from "../../../generated/graphql";
import { Button } from "../../Common/Button";
import { Section, Sections } from "../../Common/Layout";
import { Body, Title } from "../../Common/Typography";
import { ErrorMessage } from "../ErrorMessage";

export const SetupTotp = ({
  error,
  qrCode,
  dispatch,
}: Pick<LoginResponse, "qrCode" | "error"> & {
  dispatch: Dispatch<MFAFlowAction>;
}) => {
  if (!qrCode) {
    return null;
  }

  return (
    <Sections>
      {error && <ErrorMessage error={error} />}
      <Section>
        <Title type="semiBold" size="large">
          Set up Two-Factor Authentication
        </Title>
        <Body size="default" type="regular">
          Scan this QR code with your authenticator app of choice. After a code
          is provided, proceed via the button below.
        </Body>
      </Section>
      <Section style={{ alignItems: "center" }}>
        <img src={qrCode!} alt="TOTP QR Code" style={{ maxWidth: "200px" }} />
      </Section>
      <Button
        onClick={() =>
          dispatch({
            type: "setupFlowTotpCode",
            data: { qrCode, ok: true, error: null },
          })
        }
        size="medium"
        styleVariant="primary"
        stretch
      >
        Enter authentication code
      </Button>
    </Sections>
  );
};
